<template>
    <section class="content">
        <div class="container-fluid">
            <div class="block-header">
                <h2>Hasil Survey</h2>
            </div>
            <div class="row clearfix">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="card">
                        <div class="header">
                            <h2>
                                Hasil Survey
                            </h2>
                        </div>
                        <div class="body">
                            <div class="row">
                                <label class="col-sm-3">Pilih Periode</label>
                                <div class="col-sm-9">
                                    <select class="form-control" v-model="tahun">
                                        <option value="">[ Pilih Periode ]</option>
                                        <option v-bind:value="n" v-for="n in year">{{ n }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-12">
                                    <bar-chart v-if="!isLoading" :data="chartData" :options="chartOptions" :beginzero="true"></bar-chart>
                                </div>
                            </div>
                            <hr />
                        </div>
                    </div>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="card">
                        <div class="header">
                            <h2>
                                Detail Hasil Survey
                            </h2>
                        </div>
                        <div class="body">
                            <div id="DataTables_Table_0_wrapper" class="dataTables_wrapper form-inline dt-bootstrap">
                                <div class="row"><div class="col-sm-6"><div class="dataTables_length" id="DataTables_Table_0_length"><label>Show <select name="DataTables_Table_0_length" v-model="perPage" aria-controls="DataTables_Table_0" class="form-control input-sm"><option value="10">10</option><option value="25">25</option><option value="50">50</option><option value="100">100</option></select> entries</label></div></div><div class="col-sm-6"><div id="DataTables_Table_0_filter" class="dataTables_filter"><label>Search:<input v-model="search" type="search" class="form-control input-sm" placeholder="" aria-controls="DataTables_Table_0"></label></div></div></div>
                                <table class="table table-bordered table-striped table-hover js-basic-example dataTable">
                                    <thead>
                                    <tr>
                                        <th>No.</th>
                                        <th>Periode</th>
                                        <th>NIP</th>
                                        <th>Nama</th>
                                        <th>Pernyataan</th>
                                        <th>Score</th>
                                        <th>Penjelasan</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-if="isLoading">
                                        <td colspan="5" class="text-center"><i class="fa fa-spin fa-spinner"></i> Loading data...</td>
                                    </tr>
                                    <tr v-if="list == ''">
                                        <td colspan="5" class="text-center">Data tidak ditemukan</td>
                                    </tr>
                                    <tr v-if="!isLoading" v-for="(item, index) in list">
                                        <td>{{ ++index + ((currentPage-1)*perPage) }}</td>
                                        <td>{{ item.masterSurvey.periode }}</td>
                                        <td>{{ item.peserta.nip }}</td>
                                        <td>{{ item.peserta.namaPeserta }}</td>
                                        <td>{{ item.masterSurvey.pernyataan }}</td>
                                        <td>{{ item.score }}</td>
                                        <td>{{ item.penjelasan }}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            <pagination :total-rows="result.totalElements" :per-page="result.size" v-model="currentPage"></pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
  import FormLine from '@/components/FormLine.vue'
  import api from '@/helper/api'
  import qs from 'qs'
  import BarChart from '@/components/Bar'

  export default {
    components: {FormLine, BarChart},
    name: 'FormSurvey',
    data: function () {
      return {
        chartColors: [ 'rgb(255, 99, 132)', 'rgb(255, 159, 64)', 'rgb(54, 162, 235)', 'rgb(153, 102, 255)', 'rgb(201, 203, 207)', 'rgb(75, 192, 192)', 'rgb(255, 205, 86)' ],
        tahun: new Date().getFullYear(),
        result: {},
        year: [],
        list: [],
        chart: {},
        currentPage: 1,
        perPage: 10,
        search: '',
        isLoading: false,
        chartData: {
          labels: ['Sangat Baik', 'Baik', 'Cukup', 'Buruk', 'Sangat Buruk'],
          datasets: [
          ]
        },
        chartOptions: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true
              }
            }]
          },
          legend: {
            position: 'top'
          }
        }
      }
    },
    methods: {
      getData () {
        var params = []
        params.search = this.search
        params.page = this.currentPage - 1
        params.size = this.perPage

        api.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token')
        api.get('/hasil-survey' + '?' + qs.stringify(params)).then((result) => {
          this.list = result.data.content
        }).catch((ex) => {
          this.$toastr.e('Terjadi kesalahan pada server, mohon ulangi')
        })
      },
      getGrafik () {
        this.isLoading = true
        api.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token')
        api.get('/grafik-survey/?tahun=' + this.tahun).then((result) => {
          this.chart = result.data.object
          this.chartData.datasets = []

          for (let i = 0; i < this.chart.length; i++) {
            let _d = {
              data: [this.chart[i].score5, this.chart[i].score4, this.chart[i].score3, this.chart[i].score2, this.chart[i].score1],
              label: this.chart[i].masterSurvey.pernyataan,
              backgroundColor: this.chartColors[i]
            }
            this.chartData.datasets.push(_d)
          }
          this.isLoading = false
        }).catch((ex) => {
          this.$toastr.e('Terjadi kesalahan pada server, mohon ulangi')
          this.isLoading = false
        })
      }
    },
    mounted () {
      for (var i = 2017; i <= new Date().getFullYear(); i++) this.year.push(i)
      this.getData()
      this.getGrafik()
    },
    watch: {
      'tahun' (val) {
        this.getData()
        this.getGrafik()
      },
      currentPage (e) {
        this.getData()
      },
      perPage (e) {
        this.getData()
      },
      search (e) {
        this.getData()
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/view/Survey/HasilSurvey.vue